import { render, staticRenderFns } from "./FaqBlock.htm?vue&type=template&id=6f529262&scoped=true&external"
import script from "./FaqBlock.js?vue&type=script&lang=js&external"
export * from "./FaqBlock.js?vue&type=script&lang=js&external"
import style0 from "./FaqBlock.scss?vue&type=style&index=0&id=6f529262&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f529262",
  null
  
)

export default component.exports